import { Box, Button, Typography, } from '@mui/material';
import React from 'react'
import applestock from '../../../static/images/page/home/applestock.png'
import houingmarket from '../../../static/images/page/home/houingmarket.png'
import berkshirefund from '../../../static/images/page/home/berkshirefund.png'
import WestRoundedIcon from '@mui/icons-material/WestRounded';
import * as gtag from '../../../../lib/google/gtag';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import { useRouter } from 'next/router';
import * as send from '../../../../lib/analytics/send';

const PremiumBanner = ({ logout, user, screenerBanner, comp, }) => {
  const router = useRouter();
  const handleBannerClick = (e) => {
    gtag.event({ action: screenerBanner ? "screener_banner_buy" : "pricing_banner_buy" });
    send.uevent(e, screenerBanner ? "screener_banner_$1_buy" : "pricing_banner_$1_buy")
  }

  return (
    <Box
      sx={{
        // mt: 2,
        // backgroundColor: '#174c861a',
        backgroundColor: '#e3e8ee',
        // minHeight: '500px',
        maxHeight: '750px',
        height: 'calc(97vh - 100px)',
        // borderRadius: '10px',
        '-webkit-transition': 'max-height 0.3s',
        transition: 'max-height 0.3s',
        position: 'relative',
        overflow: 'hidden',
        // marginLeft: '20px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box component="div" sx={{ my: 5, }}>
        <Typography variant="body2" sx={{ bgcolor: '#2a2d64', color: '#fff', fontWeight: '500', fontSize: '.78rem', p: 1, borderRadius: '6px' }}>
          ONLY WITH PREMIUM
        </Typography>
      </Box>
      <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: '600', }}>
        Get Full Access To Grufity With Our Premium Plan
      </Typography>
      <Typography variant="body1" sx={{ color: '#2a2d64', my: 1, fontSize: '.875rem' }}>
        – starting at $8.33/month
      </Typography>
      <Box component="div"
        sx={{
          padding: '30px',
          opacity: 1,
          transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          width: '100%',
          height: '100%',
          position: 'relative',
          '&:hover .houingmarket': {
            width: '300px !important',
            top: '120px !important',
            transform: 'translate(-70%) !important',
          },
          '&:hover .berkshirefund': {
            width: '300px !important',
            top: '80px !important',
            transform: 'translate(-50%) !important',
          },
          '&:hover .applestock': {
            width: '300px !important',
            top: '40px !important',
            transform: 'translate(-30%) !important',
          },
          // '& .berkshirefund:hover': {
          //   zIndex: 2
          // }
        }}>
        <img
          src={houingmarket.src}
          alt={"houingmarket"}
          className="houingmarket"
          // layout="responsive"
          // quality={100}
          // height={60}
          // width={100}
          // blurDataURL="URL"
          // placeholder="blur"
          style={{
            filter: 'drop-shadow(rgba(61, 71, 82, 0.2) -8px 4px 20px)',
            transition: 'all 0.4s ease 0s',
            display: 'block',
            height: 'auto',
            borderRadius: '10px',
            width: '400px',
            // height: '80%',
            top: '20px',
            transform: 'translate(-75%)',
            position: 'absolute',
            left: '50%'
          }}
        />
        <img
          src={berkshirefund.src}
          alt={"berkshirefund"}
          className="berkshirefund"
          // layout="responsive"
          // quality={100}
          // height={60}
          // width={100}
          // blurDataURL="URL"
          // placeholder="blur"
          style={{
            filter: 'drop-shadow(rgba(61, 71, 82, 0.2) -8px 4px 20px)',
            transition: 'all 0.4s ease 0s',
            display: 'block',
            height: 'auto',
            borderRadius: '10px',
            width: '400px',
            // height: '80%',
            top: '180px',
            transform: 'translate(-50%)',
            position: 'absolute',
            left: '50%'
          }}
        />
        <img
          src={applestock.src}
          alt={"applestock"}
          className="applestock"
          // layout="responsive"
          // quality={100}
          // height={60}
          // width={100}
          // blurDataURL="URL"
          // placeholder="blur"
          style={{
            filter: 'drop-shadow(rgba(61, 71, 82, 0.2) -8px 4px 20px)',
            transition: 'all 0.4s ease 0s',
            display: 'block',
            height: 'auto',
            borderRadius: '10px',
            width: '400px',
            // height: '80%',
            top: '90px',
            transform: 'translate(-25%)',
            position: 'absolute',
            left: '50%'
          }}
        />
      </Box>
      <Box component="div" sx={{ bgcolor: 'primary.main', zIndex: 3, padding: 2, boxShadow: '0 0 100px rgb(0 0 0 / 60%)' }}>
        <Button href={comp && comp !== "" ? `/pricing?ref=${comp}-banner` : `/pricing?ref=banner`} sx={{ bgcolor: '#fff', my: 1, textTransform: 'none', px: 7, '&:hover': { bgcolor: '#fafafa' }, borderRadius: '7px' }} onClick={handleBannerClick}>
          {/* Try it for just $1.99 */}
          Buy Subscription
        </Button>
        <br />
        {user ?
          <Button variant="text" startIcon={<WestRoundedIcon sx={{ fontSize: '.87rem !important' }} />}
            size="small" sx={{ color: '#fff', fontSize: '.87rem', textTransform: 'none', mt: 1, borderRadius: '7px' }}
            onClick={(e) => { logout(e); send.uevent(e, "pricing-banner-login-with-different-account") }}
          >
            Login with different account
          </Button>
          :
          <Button
            variant="text"
            onClick={(e) => {
              router.push({
                pathname: '/auth',
                query: { from: router.asPath },
              });
              send.uevent(e, "pricing-banner-login-with-your-account")
            }}
            endIcon={<EastRoundedIcon sx={{ fontSize: '.87rem !important' }} />} size="small" sx={{ color: '#fff', fontSize: '.87rem', textTransform: 'none', mt: 1, borderRadius: '7px' }}>
            Login with your account
          </Button>}
      </Box>
    </Box>)
}

export default PremiumBanner
